import * as React from 'react';
import { Popper, Grow, Paper, ClickAwayListener, MenuList, MenuItem } from '@material-ui/core';
import '../AgencyFilter/agencyFilter.css'

export interface IFilterProps {
  changeStatus: (status: string) => void;
  options: any[];
  selected: string;
}

export interface IFilterState {
  selected: string;
  toggleFilter: boolean;
}

export class Filter extends React.Component<IFilterProps, IFilterState> {
  constructor(props: IFilterProps) {
    super(props);
    this.state = {
      selected: props.selected,
      toggleFilter: false
    }
  }
  public toggleFilter = (selected?) => {
    this.setState((state) => ({
      toggleFilter: !state.toggleFilter,
      selected: typeof selected === "string" ? selected : state.selected
    }));
  }
  public changeStatus = (status) => () => {
    this.toggleFilter(status);
    if (status !== this.state.selected) {
      this.props.changeStatus(status);
    }
  }
  public render() {
    return (
      <h3 className={'agencyFilter'}>
        {this.props.options.find(option => option.key === this.state.selected).value}
        <div className={"filter"}>
          <p onClick={() => this.setState({ toggleFilter: true })}>
            <i className="fa fa-filter" aria-hidden="true" />
            Filter
          </p>
          <Popper className="filterPopper" open={this.state.toggleFilter} transition={true} disablePortal={true}>
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
              >
                <Paper>
                  <ClickAwayListener onClickAway={this.toggleFilter}>
                    <MenuList>
                      {this.props.options.map(option => (
                        <MenuItem key={option.key} onClick={this.changeStatus(option.key)}>{option.value}</MenuItem>
                      ))}
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>
      </h3>
    )
  }
}



// WEBPACK FOOTER //
// ./src/share/components/Filter/Filter.tsx